// NOTE: This value belongs to the root organization admin and it's hardcoded
// in the backend and DHC, too.
export const rootOrgId = "00000000-0003-4000-8000-000000000000";

export const verifyRootOrgAdmin = (otherOrganizationId: string) => otherOrganizationId === rootOrgId;
